module.exports = __webpack_public_path__ + "static/img/QLD-10.47b214d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-10.jpg
// module id = ZpEY
// module chunks = 0